'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("welcomeService", function ($http, $modal) {
  return {
    welcome: function welcome() {
      $http.get('/rest/home/info').then(function (response) {
        var welcomeInfo = response.data;
        if (welcomeInfo.afficheWelcomeScreen) {
          return $modal.open({
            template: require("./welcome.html"),
            controller: "WelcomePopinController",
            options: {
              width: 800
            },
            vars: {
              homeInfo: welcomeInfo
            }
          });
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/welcome/welcomeService.js
// module id = 2792
// module chunks = 13